export const CLIENT_ROUTE = '/modify-request/file';
export const API_ROUTE = '/api/song-file-request';
export const CLIENT_TITLE = 'Файлтай хүсэлт';